<template>
    <div class="exhibition-management">
        <!-- 搜索和操作栏 -->
        <el-card class="search-card">
            <el-form :inline="true" :model="searchForm" class="search-form">
                <el-form-item label="展会名称">
                    <el-input
                            v-model="searchForm.title"
                            placeholder="请输入展会名称"
                            clearable
                            style="width: 200px"
                    />
                </el-form-item>

                <el-form-item label="状态">
                    <el-select
                            v-model="searchForm.status"
                            placeholder="请选择状态"
                            clearable
                            style="width: 120px"
                    >
                        <el-option label="全部" value="" />
                        <el-option label="进行中" value="ongoing" />
                        <el-option label="即将开始" value="upcoming" />
                        <el-option label="已结束" value="ended" />
                    </el-select>
                </el-form-item>

                <el-form-item label="日期范围">
                    <el-date-picker
                            v-model="searchForm.dateRange"
                            type="daterange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            value-format="yyyy-MM-dd"
                            style="width: 280px"
                    />
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="handleSearch">
                        <i class="el-icon-search"></i> 搜索
                    </el-button>
                    <el-button @click="handleReset">
                        <i class="el-icon-refresh"></i> 重置
                    </el-button>
                </el-form-item>
            </el-form>
        </el-card>

        <!-- 操作按钮 -->
        <el-card class="operation-card">
            <el-button type="primary" @click="handleAdd">
                <i class="el-icon-plus"></i> 新增展会
            </el-button>
            <el-button type="danger" @click="handleBatchDelete" :disabled="selectedRows.length === 0">
                <i class="el-icon-delete"></i> 批量删除
            </el-button>
            <el-button type="success" @click="handleExport">
                <i class="el-icon-download"></i> 导出数据
            </el-button>

            <div style="float: right">
                <el-button @click="refreshData">
                    <i class="el-icon-refresh"></i> 刷新
                </el-button>
            </div>
        </el-card>

        <!-- 数据表格 -->
        <el-card>
            <el-table
                    :data="tableData"
                    v-loading="loading"
                    @selection-change="handleSelectionChange"
                    style="width: 100%"
                    :default-sort="{ prop: 'createTime', order: 'descending' }"
            >
                <el-table-column type="selection" width="55" />

                <el-table-column prop="id" label="ID" width="80" sortable />

                <el-table-column label="封面" width="120">
                    <template slot-scope="{ row }">
                        <el-image
                                :src="row.cover"
                                fit="cover"
                                style="width: 80px; height: 60px; border-radius: 4px"
                                :preview-src-list="[row.cover]"
                        >
                            <div slot="error" class="image-slot">
                                <i class="el-icon-picture-outline"></i>
                            </div>
                        </el-image>
                    </template>
                </el-table-column>

                <el-table-column prop="title" label="展会名称" min-width="200">
                    <template slot-scope="{ row }">
                        <el-tooltip :content="row.title" placement="top">
                            <span class="title-text">{{ row.title }}</span>
                        </el-tooltip>
                        <el-tag
                                v-if="row.isHot"
                                size="mini"
                                type="danger"
                                style="margin-left: 5px"
                        >热门</el-tag>
                    </template>
                </el-table-column>

                <el-table-column prop="time" label="展会时间" width="180" sortable />

                <el-table-column prop="location" label="展会地点" width="150" />

                <el-table-column prop="status" label="状态" width="100">
                    <template slot-scope="{ row }">
                        <el-tag
                                :type="statusType[row.status]"
                                size="small"
                        >
                            {{ statusText[row.status] }}
                        </el-tag>
                    </template>
                </el-table-column>

                <el-table-column prop="exhibitors" label="展商数" width="100" sortable />

                <el-table-column prop="visitors" label="观众数" width="120" sortable />

                <el-table-column prop="createTime" label="创建时间" width="160" sortable />

                <el-table-column label="操作" width="200" fixed="right">
                    <template slot-scope="{ row }">
                        <el-button
                                type="text"
                                size="small"
                                @click="handleView(row.id)"
                        >
                            <i class="el-icon-view"></i> 查看
                        </el-button>

                        <el-button
                                type="text"
                                size="small"
                                @click="handleEdit(row)"
                        >
                            <i class="el-icon-edit"></i> 编辑
                        </el-button>

                        <el-button
                                type="text"
                                size="small"
                                style="color: #f56c6c"
                                @click="handleDelete(row.id)"
                        >
                            <i class="el-icon-delete"></i> 删除
                        </el-button>

                        <el-dropdown
                                @command="(command) => handleMoreCommand(command, row)"
                                style="margin-left: 10px"
                        >
                            <el-button type="text" size="small">
                                更多<i class="el-icon-arrow-down el-icon--right"></i>
                            </el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="copy">复制展会</el-dropdown-item>
                                <el-dropdown-item command="disable" v-if="row.status !== 'ended'">结束展会</el-dropdown-item>
                                <el-dropdown-item command="statistics">数据统计</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pagination.current"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pagination.size"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="pagination.total"
                    style="margin-top: 20px; text-align: right"
            />
        </el-card>

        <!-- 新增/编辑对话框 -->
        <el-dialog
                :title="dialogTitle"
                :visible.sync="dialogVisible"
                width="800px"
                :close-on-click-modal="false"
                @closed="handleDialogClosed"
        >
            <exhibition-form
                    ref="exhibitionForm"
                    :form-data="currentFormData"
                    :is-edit="isEditMode"
            />

            <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm" :loading="submitting">
          {{ isEditMode ? '更 新' : '创 建' }}
        </el-button>
      </span>
        </el-dialog>
    </div>
</template>

<script>
    import ExhibitionForm from './components/eExpoForm.vue'

    export default {
        name: 'ExhibitionManagement',
        components: {
            ExhibitionForm
        },
        data() {
            return {
                // 搜索表单
                searchForm: {
                    title: '',
                    status: '',
                    dateRange: []
                },

                // 表格数据
                tableData: [],
                loading: false,
                selectedRows: [],

                // 分页
                pagination: {
                    current: 1,
                    size: 10,
                    total: 0
                },

                // 对话框
                dialogVisible: false,
                dialogTitle: '',
                isEditMode: false,
                currentFormData: null,
                submitting: false,

                // 状态映射
                statusType: {
                    ongoing: 'success',
                    upcoming: 'warning',
                    ended: 'info'
                },
                statusText: {
                    ongoing: '进行中',
                    upcoming: '即将开始',
                    ended: '已结束'
                }
            }
        },

        created() {
            this.fetchData()
        },

        methods: {
            // 获取数据
            async fetchData() {
                this.loading = true
                try {
                    const params = {
                        ...this.searchForm,
                        page: this.pagination.current,
                        pageSize: this.pagination.size
                    }

                    // 调用API
                    const response = await this.$api.exhibition.getList(params)

                    this.tableData = response.data.list || []
                    this.pagination.total = response.data.total || 0
                } catch (error) {
                    this.$message.error('加载数据失败：' + error.message)
                } finally {
                    this.loading = false
                }
            },

            // 搜索
            handleSearch() {
                this.pagination.current = 1
                this.fetchData()
            },

            // 重置搜索
            handleReset() {
                this.searchForm = {
                    title: '',
                    status: '',
                    dateRange: []
                }
                this.pagination.current = 1
                this.fetchData()
            },

            // 刷新数据
            refreshData() {
                this.fetchData()
            },

            // 新增
            handleAdd() {
                this.dialogTitle = '新增展会'
                this.isEditMode = false
                this.currentFormData = null
                this.dialogVisible = true
            },

            // 编辑
            handleEdit(row) {
                this.dialogTitle = '编辑展会'
                this.isEditMode = true
                this.currentFormData = { ...row }
                this.dialogVisible = true
            },

            // 查看详情
            handleView(id) {
                this.$router.push(`/exhibition/detail/${id}`)
            },

            // 单条删除
            handleDelete(id) {
                this.$confirm('确定要删除这条展会记录吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    try {
                        await this.$api.exhibition.delete(id)
                        this.$message.success('删除成功')
                        this.fetchData()
                    } catch (error) {
                        this.$message.error('删除失败：' + error.message)
                    }
                })
            },

            // 批量删除
            handleBatchDelete() {
                if (this.selectedRows.length === 0) {
                    this.$message.warning('请选择要删除的数据')
                    return
                }

                const ids = this.selectedRows.map(item => item.id)
                this.$confirm(`确定要删除选中的 ${ids.length} 条记录吗？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    try {
                        await this.$api.exhibition.batchDelete({ ids })
                        this.$message.success(`成功删除 ${ids.length} 条记录`)
                        this.selectedRows = []
                        this.fetchData()
                    } catch (error) {
                        this.$message.error('删除失败：' + error.message)
                    }
                })
            },

            // 导出数据
            handleExport() {
                this.$confirm('确定要导出展会数据吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                }).then(async () => {
                    try {
                        const params = { ...this.searchForm }
                        const response = await this.$api.exhibition.exportData(params)

                        // 创建下载链接
                        const blob = new Blob([response], { type: 'application/vnd.ms-excel' })
                        const url = window.URL.createObjectURL(blob)
                        const link = document.createElement('a')
                        link.href = url
                        link.download = `展会数据_${new Date().getTime()}.xlsx`
                        document.body.appendChild(link)
                        link.click()
                        document.body.removeChild(link)
                        window.URL.revokeObjectURL(url)

                        this.$message.success('导出成功')
                    } catch (error) {
                        this.$message.error('导出失败：' + error.message)
                    }
                })
            },

            // 更多操作
            handleMoreCommand(command, row) {
                switch (command) {
                    case 'copy':
                        this.handleCopy(row)
                        break
                    case 'disable':
                        this.handleDisable(row.id)
                        break
                    case 'statistics':
                        this.handleStatistics(row.id)
                        break
                }
            },

            // 复制展会
            handleCopy(row) {
                this.dialogTitle = '复制展会'
                this.isEditMode = false
                // 复制数据，清除ID
                this.currentFormData = {
                    ...row,
                    id: undefined,
                    title: row.title + ' (复制)'
                }
                this.dialogVisible = true
            },

            // 结束展会
            async handleDisable(id) {
                try {
                    await this.$api.exhibition.updateStatus(id, 'ended')
                    this.$message.success('展会已结束')
                    this.fetchData()
                } catch (error) {
                    this.$message.error('操作失败：' + error.message)
                }
            },

            // 数据统计
            handleStatistics(id) {
                this.$router.push(`/exhibition/statistics/${id}`)
            },

            // 提交表单
            async submitForm() {
                try {
                    const valid = await this.$refs.exhibitionForm.validate()
                    if (!valid) return

                    this.submitting = true
                    const formData = this.$refs.exhibitionForm.getFormData()

                    if (this.isEditMode) {
                        // 更新
                        await this.$api.exhibition.update(formData.id, formData)
                        this.$message.success('更新成功')
                    } else {
                        // 新增
                        await this.$api.exhibition.create(formData)
                        this.$message.success('创建成功')
                    }

                    this.dialogVisible = false
                    this.fetchData()
                } catch (error) {
                    this.$message.error('操作失败：' + error.message)
                } finally {
                    this.submitting = false
                }
            },

            // 对话框关闭
            handleDialogClosed() {
                this.$refs.exhibitionForm.resetForm()
            },

            // 表格选择变化
            handleSelectionChange(selection) {
                this.selectedRows = selection
            },

            // 分页大小变化
            handleSizeChange(size) {
                this.pagination.size = size
                this.fetchData()
            },

            // 当前页变化
            handleCurrentChange(current) {
                this.pagination.current = current
                this.fetchData()
            }
        }
    }
</script>

<style lang="scss" scoped>
    .exhibition-management {
        padding: 20px;

        .search-card {
            margin-bottom: 20px;

            .search-form {
                margin-bottom: -20px;
            }
        }

        .operation-card {
            margin-bottom: 20px;
        }

        .title-text {
            display: inline-block;
            max-width: 200px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            vertical-align: middle;
        }

        .image-slot {
            width: 80px;
            height: 60px;
            background: #f5f7fa;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #909399;
            font-size: 24px;
        }
    }
</style>
